import * as t from './actionTypes';
import * as constants from './constants';
import dayjs from 'dayjs';

const initialState = {
    appsettings: {
        lang: 1043,
        detailwidth: 50
    },
    labels: {},
    shellSettings: {
        collapsed: true,
    },
    contentheight: 0,
    contentwidth: 0,
    gridfilterstate: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_LABELS:
            //console.log('load labels:',action.payload);
            return Object.assign({}, state, {
                labels: action.payload
            });
        case t.SET_DEBUG_LABELS:
            return Object.assign({}, state, {
                labels: {}
            });
        case t.SAVE_APPSETTINGS:
            const loc = action.payload.lang == 1043 ? 'nl' : 'en';
            dayjs.locale(loc);
            return Object.assign({}, state, {
                appsettings: action.payload
            });
        case t.LOAD_SHELLSETTINGS:
            return Object.assign({}, state, {
                shellSettings: action.payload
            });
        case t.SAVE_SHELLSETTINGS:
            return Object.assign({}, state, {
                shellSettings: action.payload
            });
        case t.SAVE_HEIGHTPARAM:
            return Object.assign({}, state, {
                contentheight: action.payload
            });
        case t.SAVE_WIDTHPARAM:
            return Object.assign({}, state, {
                contentwidth: action.payload
            });
        case t.SAVE_GRID_FILTERS:
            let n_gridfilterstate = JSON.parse(JSON.stringify(state.gridfilterstate));
            n_gridfilterstate[action.payload.gridname] = action.payload.gridstate;
            return Object.assign({}, state, {
                gridfilterstate: n_gridfilterstate
            });
        default:
            return state
    }
}